var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:news"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 5.25H19.875C20.1734 5.25 20.4595 5.36853 20.6705 5.57951C20.8815 5.79048 21 6.07663 21 6.375V18.75C21 19.3467 20.7629 19.919 20.341 20.341C19.919 20.7629 19.3467 21 18.75 21M18.75 21C18.1533 21 17.581 20.7629 17.159 20.341C16.7371 19.919 16.5 19.3467 16.5 18.75V4.125C16.5 3.82663 16.3815 3.54048 16.1705 3.32951C15.9595 3.11853 15.6734 3 15.375 3H4.125C3.82663 3 3.54048 3.11853 3.32951 3.32951C3.11853 3.54048 3 3.82663 3 4.125V17.625C3 18.5201 3.35558 19.3786 3.98851 20.0115C4.62145 20.6444 5.47989 21 6.375 21H18.75ZM7.5 7.5H12M7.5 12H12M7.5 16.5H12",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerLogo);
export default __webpack_public_path__ + "static/media/career-logo.4ef12ae2c9f526c5b09bce8cb74cd7a7.svg";
export { ForwardRef as ReactComponent };